<div class="item-container">
    <div class="information-container">
        <div class="body-1 contact-name ">{{config.contactName}}</div>
        <div *ngFor="let item of config.contactInfo; trackBy:trackByFn" class="item">
            <div class="item-title body-3">{{item.field}}: </div>
            <div class="item-value body-1">{{item.value}}</div>
        </div>
    </div>
    <div class="action-container" (click)="openContact(config)">
        <div>Open This Contact</div>
    </div>
</div>